import React from 'react'
import { graphql } from "gatsby"
import { Layout } from '@components/Layout.jsx'
import PageContent from '@contents/parts/PageContent.jsx'

const TermsCondition = ({ data }) => {
    const {page} = data?.storefront;

	return (
        <Layout gaEvent={{
			eventName: 'page_view', 
			params: {
				page_path: `/terms-and-conditions`,
				page_title: `${page?.title}`,
				queryName: 'terms and conditions page',
			},
		}}>
            <PageContent page={page} />
        </Layout>
	)
}

export default TermsCondition;


export const query = graphql`
    {
        storefront {
            page: page(handle: "terms-and-conditions") {
                title
                body
                handle
                seo {
                    description
                    title
                }
            }
        }
    }
`;